export class AudioManager {
  private static ctx: AudioContext | null = null;
  private static isMuted = false;

  private static getContext(): AudioContext | null {
    if (!this.ctx && typeof window !== 'undefined') {
      const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
      if (AudioCtx) {
        this.ctx = new AudioCtx();
      }
    }
    if (this.ctx && this.ctx.state === 'suspended') {
      this.ctx.resume();
    }
    return this.ctx;
  }

  static toggleMute(): boolean {
    this.isMuted = !this.isMuted;
    localStorage.setItem('arcade_sound_muted', String(this.isMuted));
    return this.isMuted;
  }

  static get muted(): boolean {
    if (typeof localStorage !== 'undefined') {
      this.isMuted = localStorage.getItem('arcade_sound_muted') === 'true';
    }
    return this.isMuted;
  }

  /** Web Audio API bip/bop efekti */
  static playBeep(freq = 440, duration = 0.08, type: OscillatorType = 'sine'): void {
    if (this.muted) return;
    try {
      const ctx = this.getContext();
      if (!ctx) return;

      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = type;
      osc.frequency.setValueAtTime(freq, ctx.currentTime);

      gain.gain.setValueAtTime(0.15, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start();
      osc.stop(ctx.currentTime + duration);
    } catch {
      // AudioContext policy
    }
  }

  /** Snake yem yeme sesi */
  static playEatSound(): void {
    this.playBeep(523.25, 0.06, 'triangle'); // C5
    setTimeout(() => this.playBeep(659.25, 0.08, 'triangle'), 50); // E5
  }

  /** Tetris satır silme sesi */
  static playLineClearSound(): void {
    this.playBeep(659.25, 0.08, 'square'); // E5
    setTimeout(() => this.playBeep(783.99, 0.08, 'square'), 60); // G5
    setTimeout(() => this.playBeep(1046.5, 0.12, 'square'), 120); // C6
  }

  /** Breakout / Pong sektirme sesi */
  static playBounceSound(): void {
    this.playBeep(350, 0.05, 'sine');
  }

  /** Tuğla patlama sesi */
  static playBrickBreakSound(): void {
    this.playBeep(800, 0.04, 'square');
    setTimeout(() => this.playBeep(400, 0.06, 'sawtooth'), 30);
  }

  static playScoreSound(): void {
    this.playBeep(587.33, 0.1, 'triangle');
    setTimeout(() => this.playBeep(880, 0.15, 'sine'), 80);
  }

  static playGameOverSound(): void {
    this.playBeep(300, 0.15, 'sawtooth');
    setTimeout(() => this.playBeep(220, 0.2, 'sawtooth'), 150);
    setTimeout(() => this.playBeep(150, 0.3, 'sawtooth'), 350);
  }

  static playJumpSound(): void {
    this.playBeep(400, 0.1, 'sine');
    setTimeout(() => this.playBeep(600, 0.15, 'sine'), 50);
  }

  static playLaserSound(): void {
    this.playBeep(800, 0.05, 'square');
    setTimeout(() => this.playBeep(400, 0.05, 'square'), 50);
  }

  static playExplosionSound(): void {
    this.playBeep(200, 0.1, 'sawtooth');
    setTimeout(() => this.playBeep(100, 0.2, 'sawtooth'), 50);
    setTimeout(() => this.playBeep(50, 0.3, 'sawtooth'), 100);
  }
}
